export enum PhoneCallStatus {
	DIALING = 'dialing', // Ждем ответа (звоним)
	INCOMING = 'incoming', // Входящий звонок
	CONNECTED = 'connected', // Разговор идет
	ENDED = 'ended', // Звонок завершен
}

export interface IPhoneCallState {
	status: PhoneCallStatus;
	contactName?: string;
	contactNumber: string;
	startTime?: number; // Время начала звонка (timestamp)
}

export type CallHistoryStatus = 'missed' | 'completed';

export interface ICallHistoryEntry {
	contactNumber: string;
	timestamp: number;
	status: CallHistoryStatus;
	duration?: number;
}
